import { z } from 'zod';

const selectOptionSchema = z.object({
  label: z.string(),
  value: z.union([z.string(), z.number()]),
});

export const mainValidationSchema = z.object({
  courseType: z.string().min(1, 'Categoria obrigatória'),
  course: z
    .object({
      id: z.number(),
      label: z.string(),
      offerId: z.number(),
      courseType: z.object({ type: z.string(), label: z.string() }),
      modality: z.object({ type: z.string(), label: z.string() }),
      rawCourse: z.any(),
    })
    .nullable()
    .refine((val) => val !== null, {
      message: 'Curso obrigatório',
    }),
  institution: z
    .object({ name: z.string(), id: z.number() })
    .nullable()
    .refine((val) => val !== null, {
      message: 'Instituição de ensino obrigatória',
    }),
  link: z
    .string()
    .optional()
    .nullable()
    .transform((val) => (val === '' ? undefined : val))
    .pipe(z.url('URL inválida').optional().nullable()),
  offerIdentifier: z.union([z.null(), z.string()]),
  requestReason: z.string(),
  salesType: z.string().min(1, 'Tipo de pagamento obrigatório'),
});

const modalitySchema = z
  .object({
    campus: selectOptionSchema.nullable(),
    city: selectOptionSchema.nullable(),
    modality: z.string(),
    period: selectOptionSchema.nullable(),
    state: selectOptionSchema.nullable(),
    amount: z.coerce.number().nullable(),
  })
  .superRefine(({ campus, city, period, state, amount }, ctx) => {
    if (!state) {
      ctx.addIssue({
        code: 'custom',
        message: 'Estado obrigatório',
        path: ['state'],
      });
    }
    if (!city) {
      ctx.addIssue({
        code: 'custom',
        message: 'Cidade obrigatória',
        path: ['city'],
      });
    }
    if (!campus) {
      ctx.addIssue({
        code: 'custom',
        message: 'Polo obrigatório',
        path: ['campus'],
      });
    }
    if (!period) {
      ctx.addIssue({
        code: 'custom',
        message: 'Turno obrigatório',
        path: ['period'],
      });
    }

    if (state && city && campus && period) {
      if (amount === null || amount === undefined) {
        ctx.addIssue({
          code: 'custom',
          message: 'Valor obrigatório',
          path: ['amount'],
        });
      } else if (amount < 0) {
        ctx.addIssue({
          code: 'custom',
          message: 'Valor deve ser maior ou igual a zero',
          path: ['amount'],
        });
      }
    }
  });

const durationSchema = z
  .object({
    disableDuration: z.boolean(),
    duration: z.coerce.number().nullable(),
    durationType: z.string(),
  })
  .superRefine(({ disableDuration, duration, durationType }, ctx) => {
    if (duration !== null && duration < 0) {
      ctx.addIssue({
        code: 'custom',
        message: 'Valor deve ser maior que zero',
        path: ['duration'],
      });
    }

    if (!disableDuration) {
      if (!duration) {
        ctx.addIssue({
          code: 'custom',
          message: 'Duração obrigatória',
          path: ['duration'],
        });
      }
      if (!durationType) {
        ctx.addIssue({
          code: 'custom',
          message: 'Tipo de duração obrigatório',
          path: ['durationType'],
        });
      }
    }
  });

export const formValidationSchema = mainValidationSchema
  .and(modalitySchema)
  .and(durationSchema);

export type FormValidationSchema = z.infer<typeof formValidationSchema>;
